import { React, PropTypes, createContext, useContext } from '../../lib/imports';
import { imageList } from '../../lib/images';
import { childrenPropType } from '../../lib/shared-prop-types';
import { prefixCdnUrl, getAssetSet } from './utils';

const CDN_URL = 'https://cdn.rbi.digital/hockey/';
const ConfigContext = createContext();

const ConfigProvider = ({ config, children }) => (
  <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
);

ConfigProvider.propTypes = {
  config: PropTypes.object,
  children: childrenPropType,
};

const useConfig = () => {
  const context = useContext(ConfigContext);

  if (context === undefined) {
    throw new Error(' useConfig must be used within a ConfigProvider');
  }

  return context;
};

const useCdnUrl = () => {
  return CDN_URL;
};

const useCdnImage = (ids) => {
  const version = process.env.APP_VERSION;
  return prefixCdnUrl(CDN_URL, Array.isArray(ids) ? ids : [ids], imageList(version));
};

export { ConfigProvider, useConfig, useCdnUrl, useCdnImage, getAssetSet };
